module.exports = require('./squaredLength')
